export default __webpack_public_path__ + "media/images/images_v2/actright-a6affbd67d8b5bb63b29f40d0fdd388a.png";